<template>
  <material-card
    :title="title"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0>
        <v-layout
          wrap>
          <v-flex
            xs12
            md3
            text-xs-center>
            <v-btn
              :disabled="!isValidationOk"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onFileDownload(1)">
              {{ $t('Installation Manual') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md3
            text-xs-center>
            <v-btn
              :disabled="!isValidationOk"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onFileDownload(4)">
              {{ $t('Wiring diagram') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md3
            text-xs-center>
            <v-btn
              :disabled="!isValidationOk"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onFileDownload(2)">
              {{ $t('Configuration Manual') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs12
            md3
            text-xs-center>
            <v-btn
              :disabled="!isValidationOk"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="onFileDownload(3)">
              {{ $t('User Manual') }}
            </v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
import Vue from 'vue'

export default {
  props: {
    title: {
      type: String,
      required: true
    }
  },
  data: () => ({
    isValidationOk: false,
    consoleSettings: undefined,
    rules: {
      required: [ v => Vue.prototype.Maglink.RulesRequired(v) ]
    }
  }),
  mounted () {
  },
  methods: {
    onFileDownload (selection) {
      const INSTALLATION_MANUAL_LX4 = 'M2050 LX4 Installation Manual.pdf'
      const INSTALLATION_MANUAL_LXP = 'M2050-PLUS MagLink LX Plus Installation Manual.pdf'
      const CONFIGURATION_MANUAL = 'M2051 LX 4 and LX Plus Configuration Manual.pdf'
      const USER_MANUAL = 'M2052 LX 4 and LX Plus User Manual.pdf'
      const WIRING_DIAGRAM_LX4 = 'FMMxxxx-PLS LX 4 Wiring Diagram.pdf'
      const WIRING_DIAGRAM_LXP = 'FMM2058-PLS LX Plus Wiring Diagram.pdf'

      var fileName = ''
      switch (selection) {
        case 1:
          if (Vue.prototype.Maglink.isPlus) {
            fileName = INSTALLATION_MANUAL_LXP
          } else {
            fileName = INSTALLATION_MANUAL_LX4
          }
          break
        case 2:
          fileName = CONFIGURATION_MANUAL
          break
        case 3:
          fileName = USER_MANUAL
          break
        case 4:
          if (Vue.prototype.Maglink.isPlus) {
            fileName = WIRING_DIAGRAM_LXP
          } else {
            fileName = WIRING_DIAGRAM_LX4
          }
          break
      }
      this.Maglink.FileWebDownload(fileName)
        .then(response => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]))
          var fileLink = document.createElement('a')

          fileLink.href = fileURL
          fileLink.setAttribute('download', fileName)
          document.body.appendChild(fileLink)

          fileLink.click()
          window.URL.revokeObjectURL(fileLink.href)
        })
        .catch(error => {
          this.snack('error', error.message)
        })
    },
    snack (color, message) {
      message = this.title + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
